<template>
  <ul class="collection">
    <li
        v-for="person in persons"
        :key="person.person_id"

        class="collection-item avatar"
    >
      <span class="new badge id grey darken-2 nonew">{{ person.person_id }}</span>

      <span v-if="isAdmin(person.person_id)" class="new nonew badge deep-purple darken-4">Attuale amministratore</span>
      <span v-if="person.user_id === 0" class="badge new nonew yellow">Nessun utente creato</span>
      <span v-else-if="person.user_id < 0" class="badge new nonew red">Errore creazione utente</span>
      <span v-else>
          <span v-if="person.activation !== ''" class="badge new nonew orange">Utente mai attivato</span>
          <span v-if="parseInt(person.block) === 1" class="badge new nonew red">Utente bloccato</span>
      </span>

      <img :src="profileImage(person.image_profile)" :alt="'Foto di '+person.surname+' '+person.name" class="circle">
      <span class="title">{{ person.surname }} {{ person.name }}</span>

      <button
          class="btn secondary-content"
          type="button"
          v-if="isCapable(person.person_id)"
          @click="selectThis(person.person_id)"
      >
        <i
          class="material-icons">touch_app</i>
      </button>
    </li>
  </ul>
</template>

<script>
import adaptProfileImage from "../../vue/mixins/adaptProfileImage";

export default {
  name: "GroupSelectperson",
  props: {
    persons: {
      required: true,
      type: Array
    },
    admins: {
      required: true,
      type: Array
    }
  },
  methods: {

    selectThis(pid) {
      const uid = this.persons.find( x => x.person_id === pid).user_id;
      this.$emit('change', {
        personId: pid,
        userId: uid,
      });
    },

    profileImage: function (image) {
      if (image === '') {
        return '/media/com_asdgest/images/placeholder/profile.png';
      }
      const returned = adaptProfileImage(image);
      return returned !== '' ? returned : '/media/com_asdgest/images/placeholder/profile.png';
    },

    /**
     * Check if a person is eligible to be an admin for that group
     * @param person_id
     * @returns {boolean} Indicate if the user is capable of becoming an admin
     */
    isCapable(person_id) {
      if (this.isAdmin(person_id))
        return false;

      let person = this.persons.find( x => x.person_id === person_id);
      if (!person) {
        console.log('Check what\'s going on here, bud');
        return false;
      }

      // User does not exists (and if below zero: error on creation)
      if (person.user_id <= 0) {
        return false;
      }

      // User was not activated
      if (person.activation !== '') {
        return false;
      }

      // User was blocked
      if (parseInt(person.block) === 1) {
        return false;
      }

      return true;
    },

    isAdmin(person_id) {
      return this.adminsIds.find(x => x === person_id) !== undefined;
    },
  },

  computed: {

    adminsIds: function () {
      let ret = [];
      for (let admin of this.admins) {
        if (admin.person_id > 0) {
          const person = this.persons.find((value, i) => value.person_id === admin.person_id);
          if (person) ret.push(admin.person_id);
        }
      }
      return ret;
    },

    adminsPersons: function () {
      let ret = [];
      for (let admin of this.admins) {
        if (admin.person_id > 0) {
          const person = this.persons.find((value, i) => value.person_id === admin.person_id);
          if (person) {
            ret.push({
              ...person,
              owner: admin.id === 'owner_id',
              id: admin.id
            });
          }
        } else {
          ret.push({
            person_id: 0,
            name: '',
            surname: '',
            owner: admin.id === 'owner_id',
            profile_image: '',
            id: admin.id
          });
        }
      }
      console.log('admins are',ret, this.admins);
      return ret;
    }
  },
}
</script>

<style scoped>

</style>
